<script setup>
import {computed, toRefs} from 'vue'
import {formatPercentage} from '@/helpers/numbers.js'

//Props
const props = defineProps({
  fraction: {
    type: Number,
    required: true,
  },
  options: {
    type: Object,
    default: () => ({}),
  },
  emptyLabel: {
    type: String,
    default: '',
  },
})

//Refs
const {fraction, options, emptyLabel} = toRefs(props)
const percentage = computed(() => formatPercentage(
  fraction.value, options.value, emptyLabel.value
))
</script>

<template>
  <span>{{ percentage }}</span>
</template>
